import addRoute from '@/router/add-route';

const PlanForm = () => import('@/modules/plans/plan-form.vue');

const plans = [
    addRoute({
        name: 'add-plan',
        path: '/plans/add/:productId?/:productUnit?',
        component: PlanForm,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default plans;
